/* eslint-disable no-underscore-dangle */
import {useQuery} from '@apollo/client';
import {GetTournamentsData} from 'packages/common-types/queries-types';
import {Tournament} from 'packages/common-types/schema-types';
import HeadingTitle from 'packages/common-ui/HeadingTitle';
import {GET_TOURNAMENTS} from 'packages/graphql/v2/queries';
import useAppDispatch from 'packages/hooks/use-app-dispatch';
import useAppSelector from 'packages/hooks/use-app-selector';
import Select from 'react-select';
import {selectStanding, setSelectedStanding} from 'redux/features/app-slice';
import LeaderBoard from './LeaderBoard';
import useStyles from './standing-styles';

const Standings = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const selectedTournament = useAppSelector(selectStanding);
  const {data, loading} = useQuery<GetTournamentsData>(GET_TOURNAMENTS);

  const handleSelectTournament = (value: any) => {
    dispatch(setSelectedStanding(value));
  };

  const activeTournaments = data?.getTournaments.filter(
    (t) => t.status === 'Iniciado'
  );

  return (
    <>
      <div className={classes.root}>
        <Select
          isLoading={loading}
          value={selectedTournament}
          onChange={handleSelectTournament}
          placeholder="Selecciona un torneo"
          options={activeTournaments}
          getOptionLabel={(option: Tournament) =>
            `${option.name}:${option.conditions.modalityGame}`
          }
          getOptionValue={(option: Tournament) => JSON.stringify(option)}
        />
        {selectedTournament && (
          <HeadingTitle
            title={`Puntuaciones en ${selectedTournament?.name} ${selectedTournament.conditions.modalityGame} `}
          />
        )}
        <LeaderBoard idTournament={selectedTournament?._id} />
      </div>
    </>
  );
};

export default Standings;
